import React, { useState } from 'react'

import clsx from 'clsx'
import htmlParse from 'html-react-parser'

import Html from 'components/Html'
import Typography from 'components/Typography'

import classes from './HtmlCollapsibleText.module.scss'

const DEFAULT_MAX_NUMBER_CHARS = 100
const noop = () => {}

/** @type {import("./types").default} */
const HtmlCollapsibleText = ({
  className,
  collapseLabel = 'Read less',
  expanded = false,
  expandLabel = 'Read more',
  hasSearch = false,
  maxNumberChars = DEFAULT_MAX_NUMBER_CHARS,
  offset = 0.2,
  onButtonClick = noop,
  text = '',
  textVariant,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  const needsCollapsing = text.length > maxNumberChars * (1 + offset)

  // Split text into visible and hidden parts
  const visibleText = needsCollapsing && !isExpanded ? text.substring(0, maxNumberChars) : text

  const hiddenText = needsCollapsing && !isExpanded ? text.substring(maxNumberChars) : ''

  const handleButtonClick = event => {
    const newExpandedValue = !isExpanded
    setIsExpanded(newExpandedValue)
    onButtonClick(event, { isExpanded: newExpandedValue })
  }

  return (
    <div className={clsx('HtmlCollapsibleText', classes.container, className)}>
      <Typography className={clsx(classes.text, classes.highlightText)} variant={textVariant}>
        <span data-testid="collapsible-text">
          <span data-testid="visible-text">
            <Html>{hasSearch ? htmlParse(visibleText) : visibleText}</Html>
          </span>
          {needsCollapsing && !isExpanded && <span data-testid="ellipsis" className={classes.ellipsis} />}
          <span data-testid="hidden-text" className={clsx({ [classes.hiddenText]: !isExpanded })}>
            {hasSearch ? htmlParse(hiddenText) : hiddenText}
          </span>
        </span>
        {needsCollapsing && (
          <button type="button" className={classes.button} onClick={handleButtonClick}>
            <Typography variant={textVariant}>{isExpanded ? collapseLabel : expandLabel}</Typography>
          </button>
        )}
      </Typography>
    </div>
  )
}

export default HtmlCollapsibleText
